import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction } from '../../../store/generalSlice';
import Spinner from '../../../layout/Spinner';

const WebhookField = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, state, setState } = props;

  const { incomingWebhooks } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'incomingWebhooks',
        route: 'incomingWebhooks/getIncomingWebhooks',
      })
    );
  }, []);

  const updateValue = (e, fieldName) => {
    setState((prevState) => {
      if (typeof prevState[field.id].value !== 'object') {
        return {
          ...prevState,
          [field.id]: {
            ...prevState[field.id],
            value: { [fieldName]: e.target.value },
          },
        };
      }
      return {
        ...prevState,
        [field.id]: {
          ...prevState[field.id],
          value: { ...prevState[field.id].value, [fieldName]: e.target.value },
        },
      };
    });
  };

  const SaveButton = () => {
    return (
      <>
        <button
          className='btn btn-sm btn-success mt-2'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state },
              })
            );
          }}
        >
          Save
        </button>
      </>
    );
  };

  return field && state && setState && Array.isArray(incomingWebhooks) ? (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>{field.id}: </b>
        {field.description}
      </label>
      {state[field.id]?.isUseSource ? (
        <h5>Using Source Data</h5>
      ) : (
        <div>
          <label>Choose a webhook</label>
          <select
            className='form-control'
            value={typeof state[field.id]?.value === 'object' ? state[field.id].value.webhook_id : undefined}
            onChange={(e) => (e.target.value ? updateValue(e, 'webhook_id') : null)}
            disabled={state[field.id] ? state[field.id].isUseSource : null}
          >
            <option value={null}>Select Webhook</option>
            {incomingWebhooks.map((wh) => (
              <option key={wh._id} value={wh._id}>
                {wh.name}
              </option>
            ))}
          </select>
          {state[field.id]?.value?.webhook_id !== action[fieldName][field.id]?.value?.webhook_id ? (
            <SaveButton />
          ) : null}
        </div>
      )}
      <div className='form-check mt-2'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => {
            setState((prevState) => {
              return {
                ...prevState,
                [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
              };
            });
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
              })
            );
          }}
        />
        <label className='form-check-label'>Use Source</label>
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default WebhookField;
